import {ShortUser} from './ShortUser';
import {Image} from './Image';
import {Competition} from './Competition';
import {LinkedEntity} from './LinkedEntity';
import {District} from './District';
import {Match} from './Match';
import {CompetitionSeason} from './CompetitionSeason';
import {TeamSeason} from './TeamSeason';
import {Club} from './Club';

export class MatchPlaylist {
  readonly id: number;
  readonly slug: string;
  readonly title: string;
  readonly match?: Match;
  readonly user?: ShortUser;
  readonly userAlias: string;
  readonly dateCreated: string;
  readonly updatedAt: string;
  readonly recorderId: number;
  readonly isActive: boolean;
  readonly videosCount: number;
  readonly thumbnail?: Image | null;
  readonly competition?: Competition;
  readonly links?: {
    competitions?: LinkedEntity<CompetitionSeason>[];
    teams?: LinkedEntity<TeamSeason>[];
    districts?: LinkedEntity<District>[];
    clubs?: LinkedEntity<Club>[];
  };
}
